import React from "react";
import OrdersTab from "../OrdersTab/OrdersTab";
import CancelButton from "../../components/CancelButton/CancelButton";
import { ABAS, TABS } from "../../config/tabs";

const ALERT = {
  severity: "error",
  message:
    "Os pedidos abaixo estão a mais de 3 dias sem retirada, aguardando confirmação de coleta ou cancelamento.",
};

export default function ThreeDaysStuckPage(props) {
  return (
    <OrdersTab
      {...props}
      alert={ALERT}
      aba={ABAS.PARADO_3_DIAS}
      gaTab={TABS.TRES_DIAS_PARADO}
      gaCountKey="parado3Dias"
      renderActions={(pedido, ctx) =>
        ctx.canInlineCancel ? (
          <CancelButton pedido={pedido} setState={ctx.setState} />
        ) : null
      }
    />
  );
}
